const RankTestIDs = {
  rankProgressCard: 'rank-progress-card',
  rankAdvancementBanner: 'rank-advancement-banner',

  rankProgressTitle: 'rank-progress-title',
  rankProgressDescription: 'rank-progress-description',
  rankSeeProgress: 'rank-see-progress',
  rankProgressBar: 'rank-progress-bar',
  rankIcon: 'rank-icon',

  rankFQV: 'rank-FQV',
  rankGQV: 'rank-GQV',
  rankQualifyingPoints: 'rank-qualifying-points',
  rankOrderingEntities: 'rank-ordering-entities',
  rankSeniorCoachTeams: 'rank-senior-coach-teams',
  rankExecutiveDirectorTeams: 'rank-executive-director-teams',
  rankFIBCTeams: 'rank-FIBC-teams',
  rankCertified: 'rank-certified',

  listItemLabel: 'list-item-label',
  listItemSuffix: 'list-item-suffix',
  listItemPrefix: 'list-item-prefix',
  listItemProgress: 'list-item-progress',
  listItemPercentage: 'list-item-percentage',
  listItemFractionBefore: 'list-item-fraction-before',
  listItemFractionAfter: 'list-item-fraction-after',

  rankMonthIcon: 'rank-month-checkbox-',
  rankMonthView: 'rank-month-view',
  rankMonth: 'rank-month',
  rankMonthEarned: 'rank-month-earned',
};

export default RankTestIDs;
